import React, { createContext, useState, useEffect } from "react"; 
import Papa from 'papaparse';

const CsvContext = createContext();

const CsvProvider = ({ children }) => {
    const [optionsData, setOptionsData] = useState([]);
    const [segmentsData, setSegmentsData] = useState([]);
    const [indicesData, setIndicesData] = useState([]);

    useEffect(() => {
        fetch('/data/Indices.csv')
            .then(res => res.text())
            .then(csvText => {
                Papa.parse(csvText, {
                    header: true,
                    complete: (res) => setIndicesData(res.data),
                    error: (err) => {
                        console.error('Error loading Indices Data: ', err)
                    }
                })
            });

        fetch('/data/Segments.csv')
            .then(res => res.text())
            .then(csvText => {
                Papa.parse(csvText, {
                    header: true,
                    complete: (res) => setSegmentsData(res.data),
                    error: (err) => {
                        console.error('Error loading Segments Data: ', err)
                    }
                })
            });

        fetch('/data/Options.csv')
            .then(res => res.text())
            .then(csvText => {
                Papa.parse(csvText, {
                    header: true,
                    complete: (res) => setOptionsData(res.data),
                    error: (err) => {
                        console.error('Error loading Options Data: ', err)
                    }
                })
            });

    }, []);

    return (
        <CsvContext.Provider value={{ optionsData, segmentsData, indicesData }}>
            {children}
        </CsvContext.Provider>
    );
};

export { CsvContext, CsvProvider };